import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import { createHead } from "@vueuse/head";
import { createPinia } from "pinia";
import "./styles/main.scss";
import vuetify from "./plugins/vuetify";
import resizeObserverHandler from "./utils/resizeObserverHandler";
import TextDateInput from "./components/TextDateInput.vue";
const app = createApp(App);
app.use(router);
app.use(createHead());
app.use(createPinia());
app.use(vuetify);
app.component("TextDateInput", TextDateInput);
// Handle ResizeObserver warnings
resizeObserverHandler();
app.mount("#app");
